import { DateTime } from '@aibees/shared/components';
import { DATE_FORMAT_MMM_YYY, classnames } from '@aibees/shared/utils';
import { Typography, TypographyProps } from '@mui/material';
import { memo } from 'react';
import { useIsCurrentJob } from '../../hooks/use-is-current-job';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryDateProps as Props } from './types';
import { getWorkHistoryDates } from './utils';

export const WorkHistoryDate = memo(({ className, item, ...other }: Props) => {
  const isCurrentJob = useIsCurrentJob(item);
  const typographyProps: TypographyProps = {
    ...other,
    ...{ variant: 'body4', display: 'flex', color: 'grey.500' },
  };

  const { startDate, endDate } = getWorkHistoryDates(item);

  return (
    <Styled.Wrapper
      className={classnames('WorkHistoryDate', className)}
      sx={SX.root}
    >
      {startDate && (
        <>
          <DateTime
            value={startDate}
            tooltipFormat={DATE_FORMAT_MMM_YYY}
            noTime
            {...typographyProps}
            color="grey.500"
          />
          <Typography color="grey.500" {...typographyProps}>
            -
          </Typography>
        </>
      )}
      {isCurrentJob ? (
        <Typography color="grey.500" {...typographyProps}>
          Present
        </Typography>
      ) : (
        endDate && (
          <DateTime
            value={endDate}
            tooltipFormat={DATE_FORMAT_MMM_YYY}
            noTime
            {...typographyProps}
          />
        )
      )}
    </Styled.Wrapper>
  );
});
